import { render } from "./ent-standing.component.vue?vue&type=template&id=3bc21545&ts=true"
import script from "./ent-standing.component.vue?vue&type=script&lang=ts"
export * from "./ent-standing.component.vue?vue&type=script&lang=ts"

import "./ent-standing.component.vue?vue&type=style&index=0&id=3bc21545&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__